import(/* webpackMode: "eager" */ "/vercel/path0/src/app/archive/page.js");
